import React from 'react';
import { Dialog } from '@headlessui/react';
import shieldLock from '../../shared/assets/icons/shield_lock.png';
import Styles from './Styles.module.css';
import { useIntl } from 'react-intl';
import { formatErrorDetail } from '../../shared/api/apiError';

export const ErrorModal = ({ setErrorModalShow, isErrorModalShow }) => {
	const intl = useIntl();
	// Last line of defence: this modal is reachable from every module, so flatten
	// whatever `message` arrived with rather than trusting each caller.
	const message = formatErrorDetail(
		isErrorModalShow?.message,
		'An error occurred',
	);
	const isSessionExpired = message.includes('session has expired');

	const handleRedirect = () => {
		setErrorModalShow(null);
		// Check if this is a session expired message
		if (isSessionExpired) {
			window.location.replace('/sign-in');
		} else {
			window.location.replace('/');
		}
	};

	// Render session expired modal with new design
	if (isSessionExpired) {
		return (
			<Dialog
				open={true}
				onClose={() => setErrorModalShow(null)}
				className={Styles.containerBox}
			>
				<div className={Styles.sessionExpiredWrapper}>
					<div className={Styles.overlay}></div>
					<Dialog.Panel className={Styles.sessionExpiredPanel}>
						<div className={Styles.sessionExpiredContent}>
							{/* Security Icon */}
							<div className={Styles.securityIconContainer}>
								<div className={Styles.shieldBackground}>
									<img
										src={shieldLock}
										alt='Security'
										className={Styles.shieldLockIcon}
									/>
								</div>
							</div>

							{/* Title */}
							<h2 className={Styles.sessionExpiredTitle}>
								{intl.formatMessage({
									id: 'ErrorModalID1',
								})}
							</h2>

							{/* Description */}
							<div className={Styles.sessionExpiredDescription}>
								<p>{intl.formatMessage({ id: 'ErrorModalID2' })}</p>
								<p>{intl.formatMessage({ id: 'ErrorModalID3' })}</p>
							</div>

							{/* Log In button */}
							<button
								type='button'
								className={Styles.logInButton}
								onClick={handleRedirect}
							>
								{intl.formatMessage({ id: 'ErrorModalID4' })}
							</button>
						</div>
					</Dialog.Panel>
				</div>
			</Dialog>
		);
	}

	// Render default error modal for other errors
	return (
		<Dialog
			open={true}
			onClose={() => setErrorModalShow(null)}
			className={Styles.containerBox}
		>
			<div className='min-h-screen px-4 text-center'>
				<div className={Styles.overlay}></div>
				<Dialog.Panel className={Styles.dialogPanel}>
					<Dialog.Title as='h3' className={Styles.modalTitle}>
						{message}
					</Dialog.Title>

					<div className='mt-4 flex justify-end'>
						<button
							type='button'
							className={Styles.buttonComponent}
							onClick={handleRedirect}
						>
							{intl.formatMessage({ id: 'ErrorModalID5' })}
						</button>
					</div>
				</Dialog.Panel>
			</div>
		</Dialog>
	);
};
